import React from "react";
import {jssPreset, StylesProvider} from "@material-ui/core/styles";
import {create} from "jss";
import rtl from "jss-rtl";

// Configure JSS
const jss = create({plugins: [...jssPreset().plugins, rtl()]});

export default function RTLProvider({children}: {children: JSX.Element}) {
  return <StylesProvider jss={jss}>{children}</StylesProvider>;
}
